import { Link } from "react-router-dom";
import { APP_HOME_URL } from "../config";

export default function WhyRechecklist() {
  return (
    <article className="prose-page" data-tour="why-desk">
      <h1>Why REChecklist</h1>
      <p className="lead">
        The working desk. Buyers walk a discovery checklist. Sellers build a listing brief. Agents
        keep a File Packet. Brokers supervise without turning the office into a race.
      </p>
      <section>
        <h2>Two journeys, never mixed</h2>
        <p>
          Separate routes, nav, and storage. Agents and clients both leave with something usable.
          Messaging and reporting are first-class — not a bolt-on inbox.
        </p>
      </section>
      <section>
        <h2>File Packet, not a feed</h2>
        <p>
          Documents, photos, custom steps, lifecycle, and the communication archive live with the
          client file. Manuals on this site explain the why; the desk holds the work.
        </p>
      </section>
      <section>
        <h2>Admin stays on the desk</h2>
        <p>
          Controls, users, suggestions, and the site map are REChecklist admin. This site does not
          fork messaging.
        </p>
      </section>
      <p className="btn-row" style={{ justifyContent: "flex-start" }} data-tour="why-learn">
        <a className="btn" href={APP_HOME_URL}>
          Open the app
        </a>
        <Link className="btn btn-ghost" to="/why">
          Why this site
        </Link>
      </p>
    </article>
  );
}
